import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { VariantGridDataService } from '@app/@core/services/variant-grid-data/variant-grid-data.service';

@Component({
    selector: 'sp-variant-update-alert',
    templateUrl: './variant-update-alert.component.html',
    styleUrls: ['./variant-update-alert.component.scss'],
})
export class VariantUpdateAlertComponent implements OnInit {
    variantsCount: number = this.variantGridDataService.variantUpdatedCount;
    @Output() closeDeleteAlert = new EventEmitter<void>();

    constructor(private variantGridDataService: VariantGridDataService) {}

    ngOnInit(): void {}

    undoUpdateVariants(): void {
        this.variantGridDataService.updatePreviousQuantityToVaraibtGridData();
        this.closeDeleteAlert.emit();
    }

    closeUpdateAlertSnackBar(): void {
        this.closeDeleteAlert.emit();
    }
}
